import React from 'react';
import Navigation from 'components/navigation';
import { noop } from 'lodash';
import { HeaderWrapper } from 'ds/components/Layout';
import MortgageOfficesSearchPage from './MortgageOfficesSearchPage';


const MortgageOfficesSearchPageWithHeader: React.FC = () => (
  <>
    <HeaderWrapper>
      <Navigation
        isMobileMapViewActive={false}
        setMobileMapViewActive={noop}
      />
    </HeaderWrapper>
    <MortgageOfficesSearchPage />
  </>
);

export default MortgageOfficesSearchPageWithHeader;
